import { apiRequest } from "./common";

const createBlog = async (data) => {
    const response = await apiRequest('post', '/blog', data);
    return response.data;
};

const updateBlog = async (id, data) => {
    const response = await apiRequest('put', `/blog/${id}`, data);
    return response.data;
};

const deleteBlog = async (id) => {
    const response = await apiRequest('delete', `/blog/${id}`);
    return response.data;
};

const getBlogList = async (pageNo, pageSize, searchText) => {
    const response = await apiRequest('get', `/blog?page=${pageNo}&limit=${pageSize}&sort=desc${searchText !== '' ? `&search=${searchText}` : ''}`);
    return response.data;
};

const getBlog = async (id) => {
    const response = await apiRequest('get', `/blog/${id}`);
    return response.data;
};

export {
    createBlog,
    updateBlog,
    deleteBlog,
    getBlogList,
    getBlog
};
